module.exports = __webpack_public_path__ + "static/media/l7.6771ec6a.jpg";